{
  "title": "Fee Payment Accounts",
  "subTitle": "For each account, you can select a different non-registered account from which you want to withdraw fees from.",
  "noAccountsInHousehold": "There are no accounts in this household. Create or associate an account first.",
  "registeredAccounts": "Registered Accounts",
  "set": "Set Payment Accounts",
  "feePaymentAccountsUpdated": "Fee Payment Accounts have been updated"
}
